import styled, { css } from 'styled-components';

const ProgressBarContainer = styled.div(({ theme: { olist: { components: { progressbar }, }, }, }) => css `
    height: ${progressbar.height};
    width: ${progressbar.width};
    box-sizing: border-box;

    background-color: ${progressbar['background-color']};
    border-radius: ${progressbar['border-radius']};
  `);
const CurrentProgress = styled.div(({ theme: { olist: { components: { progressbar }, }, }, progress, variation = 'primary', }) => css `
    height: ${progressbar.height};
    background-color: ${progressbar.variation[variation]['background-color']};
    width: ${progress || 0}%;
    border-radius: ${progressbar['border-radius']};
  `);

export { CurrentProgress, ProgressBarContainer };
